export default "__VITE_ASSET__D9nwsXO5__"